// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Bzn4F","text":"_11mluD"};